import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./sections/Navbar";
import { Hero } from "./sections/Hero";
import { NewsRelease } from "./sections/NewsRelease";
import { About } from "./sections/About";
import { Quality } from "./sections/Quality";
import { Shop } from "./sections/Shop";
import { Distribution } from "./sections/Distribution";
import { Company } from "./sections/Company";
import { Recruit } from "./sections/Recruit";
import { Contact } from "./sections/Contact";
import { Footer } from "./sections/Footer";
import { OrderStatus } from "./sections/OrderStatus";

const Landing = () => (
  <LanguageProvider>
    <div className="bg-brand-cream text-brand-ink min-h-screen" data-testid="landing-root">
      <Navbar />
      <Hero />
      <NewsRelease />
      <About />
      <Quality />
      <Shop />
      <Distribution />
      <Company />
      <Recruit />
      <Contact />
      <Footer />
    </div>
  </LanguageProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/order/:invoice" element={<OrderStatus />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
